export const basketDataSelector = (state) => state?.components?.basket?.data ?? null
